import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { ForgeSpacePageExtensionPoint } from '@confluence/forge-ui/entry-points/SpacePage.ts';

import SpaceBase from '../../SpaceBase/index.js';

export const SpaceForgeAppsRoute: {
	({ params: { appId, envId, forgeManifestRoute, spaceKey } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ name, params: { appId, envId, forgeManifestRoute, spaceKey } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
				attributes: {
					appId: string;
					envId: string;
					forgeManifestRoute: string;
				};
			};
			pageState: {
				routeName: string;
				spaceKey: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: string;
		};
	};
} = ({ params: { appId, envId, forgeManifestRoute, spaceKey } }: RouteMatch): React.JSX.Element => {
	return (
		<SpaceBase>
			<ForgeSpacePageExtensionPoint
				key={appId + envId + forgeManifestRoute}
				spaceKey={spaceKey}
				appId={appId}
				envId={envId}
				forgeManifestRoute={forgeManifestRoute}
			/>
		</SpaceBase>
	);
};

SpaceForgeAppsRoute.NAVIGATION_PARAMS = ({
	name,
	params: { appId, envId, forgeManifestRoute, spaceKey },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			id: string;
			attributes: {
				appId: string;
				envId: string;
				forgeManifestRoute: string;
			};
		};
		pageState: {
			routeName: string;
			spaceKey: string;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: string;
	};
} => ({
	Screen: {
		screenEvent: {
			name: 'spaceForgeApps',
			id: spaceKey,
			attributes: { appId, envId, forgeManifestRoute },
		},
		pageState: {
			routeName: name,
			spaceKey,
		},
	},

	MainLayout: {
		navView: CONTAINER_HOME_ID,
		spaceKey,
	},
});
